// extracted by mini-css-extract-plugin
export default {"body":"dashboard_body__mgmV6","content":"dashboard_content__8tRJh"};